<script setup lang="ts">
import { PropType } from 'vue';

const props = defineProps({
  text: {
    type: String as PropType<string>,
  },
  color: {
    type: String as PropType<string>,
    required: false,
    default: '#2C9EB3',
  },
  loading: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
  tabindex: {
    type: Number as PropType<number>,
    require: false,
  },
});
defineEmits({
  click: null,
});

const styles = {
  backgroundColor: props.color,
};
</script>

<template>
  <div class="px-[18px]">
    <button
      class="text-white w-full rounded-[3px] h-[51px] text-[24px] font-bold"
      @click="$emit('click')"
      :style="styles"
      :disabled="loading"
      :tabindex="tabindex"
    >
      <Preloader v-if="loading" />
      <p v-else v-text="text" />
    </button>
  </div>
</template>
